import request from '@/utils/request'

/**
 * 获取调剂出库列表
 * @param {*} data
 * @returns
 */
export const getTJCKList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/list`,
    data: data
})

/**
 * 获取调剂证列表
 * @param {*} data
 * @returns
 */
 export const getTJZList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/selectTjzList`,
    data: data
})
/**
 * 获取运输证列表
 * @param {*} id
 * @param {*} data
 * @returns
 */
 export const getYSZList = (id, data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/selectYszList/${id}`,
    data: data
})

/**
 * 根据调剂证主键查询调剂证等信息
 * @param {*} id
 * @returns
 */
 export const getTJZ = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/tjck/selectTjzxxById/${id}`
})
/**
 * 获取调剂出库详情
 * @param {*} id
 * @returns
 */
 export const getTJCK = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/tjck/detail/${id}`
})


/**
 * 新增/编辑调剂出库
 * @param {*} data
 * @returns
 */
export const addOrUpdSaveTJCK = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/addOrUpdSave`,
    data: data
})


/**
 * 删除调剂出库
 * @returns
 * @param id
 */
export const deleteTJCK = (id) => request({
    method: 'delete',
    url: `/yzdservice/enterprise/dwCk/tjck/remove/${id}`
})

/**
 * （变更保存前）校验库存是否为负数
 * @param {*} data
 * @returns
 */
export const changePdkc = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/changePdkcByTjck`,
    data
})
/**
 * 变更调剂出库
 * @param {*} data
 * @returns
 */
export const saveChangeApply = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/saveChangeApply`,
    data
})

/**
 * 导出
 * @param {*} data
 * @returns
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/tjck/excelwriter`,
    data,
    responseType: 'blob'
})

